import jQuery from 'jquery';

/*--------------------------------------------------------------------------*
 *
 *  selmodal.js
 *
 *  MIT-style license.
 *
 *  2019 nocho
 *  http://kinocolog.com
 *
 *--------------------------------------------------------------------------*/

(function ($) {
  $.fn.selModal = function () {
    const SEL_PARENT = $(this);

    SEL_PARENT.each(function () {
      const select_this = $(this);

      const sel_name_attr = $(this).attr('name');
      const selected = $(this).prop('selectedIndex');
      let selected_name;
      let modal_html = '';
      let button_html = '';
      const sel_default_text = '選択してください。';
      let scrollY = 0;

      $(`[data-selmodal='${sel_name_attr}']`).remove();
      $(`[data-selmodalbtn='${sel_name_attr}']`).remove();

      const aryChild = $(this).children();

      modal_html += `<div class='selModal' data-selmodal='${sel_name_attr}'>`;
      modal_html += '<div class="selModalOverlay selModalClose"></div>';
      modal_html += '<div class="selModalInner">';
      modal_html += '<div class="selModalHeader">';
      modal_html +=
        '<div class="selModalCloseIcon selModalClose"><span></span></div>';
      modal_html += '</div>';

      modal_html += '<div class="selModalList">';
      modal_html += '<ul>';
      for (let i = 0; i < aryChild.length; i++) {
        let img_div = '';
        if (aryChild.eq(i).attr('data-image')) {
          img_div = `<img src='${aryChild.eq(i).attr('data-image')}'>`;
        }
        if (selected != i) {
          modal_html += `<li class='selModalClose' data-value='${aryChild
            .eq(i)
            .attr('value')}'>${img_div}${aryChild.eq(i).text()}</li>`;
          } else {
          modal_html += `<li class='selected selModalClose' data-value='${aryChild
            .eq(i)
            .attr('value')}'>${img_div}${aryChild.eq(i).text()}</li>`;
          selected_name = aryChild.eq(i).text();
        }
      }
      modal_html += '</ul>';
      modal_html += '</div>';
      modal_html += '</div>';

      if (selected_name === undefined) {
        button_html = `<button type='button' class='selModalButton' data-selmodalbtn='${sel_name_attr}'>${sel_default_text}</button>`;
      } else {
        button_html = `<button type='button' class='selModalButton' data-selmodalbtn='${sel_name_attr}'>${selected_name}</button>`;
      }

      // 元のセレクトボックスは非表示
      $(this).hide();
      //ボタン生成
      $(this).after(button_html);
      //モーダルウインドウ生成
      $('body').append(modal_html);

      //ボタンクリック
      $(`[data-selmodalbtn='${sel_name_attr}']`).click(function () {
        scrollY = window.pageYOffset;
        document.body.style = `position: fixed; top: -${scrollY}px;`;

        const href = $(`[data-selmodal='${$(this).data('selmodalbtn')}']`);

        $(href)
          .find('.selModalList')
          .on('scroll', (e) => {
            e.stopPropagation();
          });

        $(href).show();

        const par_height = $(href).find('.selModalInner').outerHeight();
        const c_head = $(href).find('.selModalHeader').outerHeight();
        $(href)
          .find('.selModalList')
          .css('height', `${par_height - c_head}px`);

        let pos = 0;
        let tr = 0;
        $(href)
          .find('.selModalList ul li')
          .each((key, value) => {
            if ($(value).hasClass('selected')) {
              tr = $(value).outerHeight(true);
              return false;
            } else {
              pos += $(value).outerHeight(true);
            }
          });

        const sh = $(href).find('.selModalList').height();
        if (sh > 0) pos -= sh / 2;
        if (tr > 0) pos += tr / 2;
        $(href).find('.selModalList').scrollTop(pos);
      });

      $(`[data-selmodal='${sel_name_attr}']`)
        .find('.selModalList')
        .on('touchstart', function () {
          if ($(this).scrollTop() == 0) {
            $(this).scrollTop(1);
          }
          const scrollHeight = $(this)[0].scrollHeight;
          const scrollPosition = $(this).scrollTop() + $(this).height();
          if (scrollHeight == scrollPosition) {
            $(this).scrollTop($(this).scrollTop() - 1);
          }
        });

      $(`[data-selmodal='${sel_name_attr}']`)
        .find('.selModalList li')
        .on('touchstart', function () {
          $(this).addClass('totch');
        });

      $(`[data-selmodal='${sel_name_attr}']`)
        .find('.selModalList li')
        .on('touchstart', function () {
          // iOSのSafariでダイアログの初期表示の時のみ.selModalListの高さがおかしくなるのでここで調整する
          const modalInner = $(this).parents('.selModalInner');
          const innerHeight = modalInner.outerHeight();
          const headerHeight = modalInner
            .children('.selModalHeader')
            .outerHeight();
          const modalList = $(this).parents('.selModalList');
          const listHeight = modalList.outerHeight();
          const currentListHeight = innerHeight - headerHeight;

          if (currentListHeight < listHeight) {
            modalList.css('height', `${currentListHeight}px`);
          }
        });

      $(`[data-selmodal='${sel_name_attr}']`)
        .find('.selModalList li')
        .on('touchend', function () {
          $(this).closest('ul').find('li').removeClass('totch');
        });

      //ボタンクリック
      $(`[data-selmodal='${sel_name_attr}']`)
        .find('li')
        .click(function () {
          $(this).closest('ul').find('li').removeClass('selected');
          $(this).addClass('selected');
          const hoge = $(this).closest('.selModal').data('selmodal');
          const this_no = $(this).closest('ul').find('li').index(this);
          const before_no = $(`select[name='${hoge}']`).prop('selectedIndex');
          $(`select[name='${hoge}']`).prop('selectedIndex', this_no);
          $(`[data-selmodalbtn='${hoge}']`).text($(this).text());
          if (this_no != before_no) {
            const thisName = $(select_this).attr('name');
            document
              .querySelector(`[name='${thisName}']`)
              .dispatchEvent(new Event('change'));
          }
        });

      $(`[data-selmodal='${sel_name_attr}']`)
        .find('.selModalClose')
        .click(function () {
          setTimeout(() => {
            window.scrollTo(0, scrollY);
          }, 0);
          document.body.style = 'position: static;';
          $(this).parents('.selModal').hide();
          const href = $(`[data-selmodal='${$(this).data('selmodalbtn')}']`);
          $(href).find('.selModalList').off('scroll');
        });
    });
  };

  $.fn.selModalSetValue = function (value) {
    const sel_dom = $(this);
    sel_dom.val(value);
    const sel_text = $(sel_dom).find('option:selected').text();
    const name = sel_dom.attr('name');
    const sel_list = $(`[data-selmodal='${name}']`);
    const sel_btn = $(`[data-selmodalbtn='${name}']`);

    sel_list.find('li').removeClass('selected');
    sel_list.find(`[data-value='${value}']`).addClass('selected');
    sel_btn.text(sel_text);
  };
})(jQuery);
